<template>
	<div>
		<iframe
			:key="iframeKey"
			scrolling="no"
			class="element-position "
			:class="className"
			:style="style"
			v-if="isTicker && status ==='preview'"
			:srcdoc="template()"
			:id="iframeId"
		/>
		<iframe
			:key="iframeKey"
			scrolling="no"
			class="element-position "
			:class="className"
			:style="style"
			v-if="isTicker && status ==='live'"
			:id="iframeId"
		/>
	</div>
</template>

<script>
import { duplicateVar } from '@/lib/helper';
import rundownItemsApi from '@/api/rundownItems';


export default {
	name: 'ElementTicker',
	props: {
		item: {
			type: Object,
		},
		status: {
			default: 'preview',
		},
	},
	data() {
		return {
			localItem: null,
			key: 0,
		};
	},
	sockets: {
		connect() {
			// this.activateSocket();
		},
		force_play_item(data) {
			if (this.localItem.id === data.id) {
				this.key = this.key + 1;
				this.localItem = duplicateVar(data);
				const content = this.template();
				this.$nextTick(() => {
					const iframeDocument = document.getElementById(this.iframeId).contentDocument;
					document.getElementById(this.iframeId).contentWindow.location.reload();
					iframeDocument.open('text/html', 'replace');
					iframeDocument.write(content);
					iframeDocument.close();
				});
			}
		},

	},
	created() {
		this.localItem = duplicateVar(this.item);
	},
	watch: {
		item() {
			if (this.item) {
				this.localItem = duplicateVar(this.item);
			}
		},
	},
	mounted() {
		const content = this.template();
		this.$nextTick(() => {
			if (this.status === 'live') {
				const iframeDocument = document.getElementById(this.iframeId).contentDocument;
				iframeDocument.open('text/html', 'replace');
				iframeDocument.write(content);
				iframeDocument.close();
			}
		});
	},
	methods: {
		hasProperty(obj, prop) {
			return Object.prototype.hasOwnProperty.call(obj, prop);
		},
		getTemplate() {
			// get the active template
		},
		serializeJs(js) {
			const src = js;
			const setupticker = src.replace(/__TICKERTEXT__/g, JSON.stringify(this.content.tickerData));
			const setupSpeed = setupticker.replace(/__SPEED__/g, this.content.speed);
			const setupBgColor = setupSpeed.replace(/__elementHeading__/g, `${this.content.backgroundColor}`);
			const setupFontColor = setupBgColor.replace(/__FONTCOLOR__/g, `${this.content.fontColor}`);
			const setupGradient = setupFontColor.replace(/__ISGRADIENT__/g, this.content.gradient);
			const setupAngle = setupGradient.replace(/__ANGLE__/g, this.content.angle);
			const setupTitle = setupAngle.replace(/__TITLE__/g, this.content && this.content.title ? this.content.title : ' ');
			const setupHardGradient = setupTitle.replace(/__HARDGRADIENT__/g, this.content && this.content.hardGradient ? this.content.hardGradient : false);
			const setupUseTimer = setupHardGradient.replace(/__USETIMER__/g, this.content && this.content.displayTime ? this.content.displayTime : false);
			const setupFontStyleIndex = setupUseTimer.replace(/__FONTINDEX__/g, this.content && this.content.fontStyle ? this.content.fontStyle : 0);

			return setupFontStyleIndex;
		},
		serializeHTML(template) {
			const src = template;
			const setupElementHeading = src.replace(/__elementHeading__/g, `${this.content.backgroundColor}!important`);
			// const setupHeading = setupElementHeading.replace(/__heading__/g, this.content.heading);
			// const setupElementSubHeading = setupHeading.replace(/__elementSubHeading__/g, `${this.content.subElement_color}!important`);
			// const setupSubHeading = setupElementSubHeading.replace(/__subHeading__/g, this.content.sub_heading);
			// const replaceFontFamily = setupSubHeading.replace(/__fontFamily__/g, `${this.content.font_family}!important`);
			// const replaceFontSize = replaceFontFamily.replace(/__fontSize__/g, `${this.content.font_size}px!important`);
			// const setupFontColorHeading = replaceFontSize.replace(/__fontColorHeading__/g, `${this.content.headingFont_color}!important`);
			// const setupFontColorSub = setupFontColorHeading.replace(/__fontColorSub__/g, `${this.content.subFont_color}!important`);

			let tickerTexts = '';
			// if (this.playlist.category === 'ticker') {
			if (this.content.tickerData) {
				if (this.content.tickerData.length !== 0) {
					const tickers = this.content.tickerData;
					for (let index = 0; index < tickers.length; index++) {
						const tickerText = tickers[index];
						tickerTexts += `<div class="ticker__item"  style="color:${this.content.fontColor}">${tickerText}</div>
								`;
					}
				}
			}
			// }
			const setupticker = setupElementHeading.replace(/__TICKERTEXT__/g, tickerTexts);
			return setupticker;
		},
		template() {
			let setupTemplate = '';
			// const iframe = document.querySelector(`ticker-${this.localItem.slug}`);
			// const templateRaw = this.localItem.content && this.localItem.content.template !== ''
			// 	? JSON.parse(this.localItem.content.template) : {};
			const template = this.content.template && this.content.template.content ? JSON.parse(this.content.template.content) : null;
			if (template) {
				const finalCSS = template.style;
				const finalJS = this.serializeJs(template.script);
				const finalHTML = this.serializeHTML(template.content);

				setupTemplate = `
								<html>
								<head>
								<style>${finalCSS}</style>
								<script src="https://grafias-medias.s3.eu-central-1.amazonaws.com/js/jquery-3.5.1.min.js" >
								<\/script>
								</head>
								<body>
									${finalHTML}
								</body>
								<script>${finalJS}<\/script>
								</html>
				`;
			// iframe.srcdoc = setupTemplate;
			}
			return setupTemplate;
		},
		onCompletePlay(itemId) {
			const callback = () => {
			};
			const errorCallback = () => {
			};
			rundownItemsApi.playLive(itemId, callback, errorCallback);
		},
	},
	beforeDestroy() {
		// if (this.status === 'live') {
		// 	if (this.content && this.content.onCompleteItem) {
		// 		this.onCompletePlay(this.content.onCompleteItem);
		// 	}
		// }
	},
	computed: {
		content() {
			return this.localItem.content && this.localItem.content !== ''
				? JSON.parse(this.localItem.content) : {};
		},
		className() {
			return this.content.position ? this.content.position : '';
		},
		style() {
			const style = {};
			style.position = 'absolute';
			style.border = '0';
			style.zIndex = this.localItem.layer_index;
			const content = this.content;
			if (content.opacity) style.opacity = content.opacity;
			if (content.width) style.width = `${content.width}px`;
			if (content.height) style.height = `${content.height}px`;
			if (content.y) style.top = `${content.y}px`;
			if (content.x) style.left = `${content.x}px`;
			return style;
		},
		isTicker() {
			return this.localItem.type === 'ticker';
		},
		zoomUrl() {
			return this.localItem;
		},
		iframeId() {
			return `ticker-${this.status}${this.localItem.slug}`;
		},
		iframeKey() {
			return `ticker-${this.status}${this.localItem.slug}-${this.key}`;
		},
	},

};
</script>
